import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function TrackingScripts() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    // Fetch settings on mount
    axios.get(`${API}/api/settings`)
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!settings) return;

    // Google Analytics (GA4)
    if (settings.google_analytics_id && settings.google_analytics_id.startsWith('G-')) {
      // Load gtag script
      if (!document.getElementById('ga-script')) {
        const script = document.createElement('script');
        script.id = 'ga-script';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${settings.google_analytics_id}`;
        document.head.appendChild(script);
        
        // Initialize gtag
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        window.gtag = gtag;
        gtag('js', new Date());
        gtag('config', settings.google_analytics_id);
      }
    }

    // Google Tag Manager
    if (settings.google_tag_manager_id && settings.google_tag_manager_id.startsWith('GTM-')) {
      if (!document.getElementById('gtm-script')) {
        // Head script
        const script = document.createElement('script');
        script.id = 'gtm-script';
        script.innerHTML = `
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${settings.google_tag_manager_id}');
        `;
        document.head.appendChild(script);
        
        // Body noscript (for fallback)
        if (!document.getElementById('gtm-noscript')) {
          const noscript = document.createElement('noscript');
          noscript.id = 'gtm-noscript';
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.googletagmanager.com/ns.html?id=${settings.google_tag_manager_id}`;
          iframe.height = '0';
          iframe.width = '0';
          iframe.style.display = 'none';
          iframe.style.visibility = 'hidden';
          noscript.appendChild(iframe);
          document.body.insertBefore(noscript, document.body.firstChild);
        }
      }
    }

    // Facebook Pixel
    if (settings.facebook_pixel_id && settings.facebook_pixel_id.length >= 10) {
      if (!document.getElementById('fb-pixel-script')) {
        const script = document.createElement('script');
        script.id = 'fb-pixel-script';
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${settings.facebook_pixel_id}');
          fbq('track', 'PageView');
        `;
        document.head.appendChild(script);
        
        // Noscript fallback
        if (!document.getElementById('fb-pixel-noscript')) {
          const noscript = document.createElement('noscript');
          noscript.id = 'fb-pixel-noscript';
          const img = document.createElement('img');
          img.height = 1;
          img.width = 1;
          img.style.display = 'none';
          img.src = `https://www.facebook.com/tr?id=${settings.facebook_pixel_id}&ev=PageView&noscript=1`;
          noscript.appendChild(img);
          document.head.appendChild(noscript);
        }
      }
    }

    // Update meta tags
    if (settings.site_title) {
      document.title = settings.site_title;
    }
    if (settings.site_description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'description';
        document.head.appendChild(meta);
      }
      meta.content = settings.site_description;
    }
    if (settings.meta_keywords) {
      let meta = document.querySelector('meta[name="keywords"]');
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'keywords';
        document.head.appendChild(meta);
      }
      meta.content = settings.meta_keywords;
    }

  }, [settings]);

  // This component doesn't render anything visible
  return null;
}

// Helper to track custom events
export function trackEvent(eventName, params = {}) {
  // Google Analytics
  if (window.gtag) {
    window.gtag('event', eventName, params);
  }
  
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', eventName, params);
  }
}

// Track page views (call on route changes)
export function trackPageView(path) {
  // Google Analytics
  if (window.gtag) {
    window.gtag('config', window.GA_MEASUREMENT_ID, {
      page_path: path
    });
  }
  
  // Facebook Pixel
  if (window.fbq) {
    window.fbq('track', 'PageView');
  }
}
